import { Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatIconButton, MatButton } from '@angular/material/button';
import { ClickAndKeydownDirective } from '@directives/click-and-keydown.directive';
import { MatIcon } from '@angular/material/icon';
import { MessageBoxComponent } from '@akelius/angular-ui-kit';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.less'],
    imports: [MatIconButton, ClickAndKeydownDirective, MatIcon, MessageBoxComponent, MatButton, TranslateModule]
})
export class NotificationComponent {
    private dialogRef = inject<MatDialogRef<NotificationComponent>>(MatDialogRef);

    save(): void {
        this.dialogRef.close(true);
    }

    close(): void {
        this.dialogRef.close(false);
    }
}
